import { BuildingOfficeOrderSiteMenuList } from "../../utils/constants";
import { TableStructure } from "../../components/TableStructure";

const List = [
  {
    fileStoreId: "378c3f3b-d183-428e-8725-049a7708a5f4",
    label: "DG(BLDG)'s Office Order No. 23 of 2019-2020",
    date: "27/01/2020",
    subject: "Complaints of Board of Auqaf",
  },
  {
    fileStoreId: "ce3f957d-2354-4583-8744-b62dd5e9aed6",
    label: "DG(BLDG)'s Office Order No. 20 of 2019-2020",
    date: "14/01/2020",
    subject: "To dispose plan cases pending more than six month",
  },
  {
    fileStoreId: "8e01628d-5b4b-47e0-bc1f-ac97f422c876",
    label: "DG(BLDG)'s Office Order No. 19 of 2019-2020",
    date: "04/01/2020",
    subject: "Information to be furnished for the proposals us 400",
  },
  {
    fileStoreId: "a2ea4444-1378-4792-8c25-a34f187865f3",
    label: "DG(BLDG)'s Office Order No. 15 of 2019-2020",
    date: "26/09/2019",
    subject: "Communication of Order of SOB to all concern",
  },
  {
    fileStoreId: "1ac746e7-c7b7-48d8-a9f2-0213d71985f6",
    label: "DG(BLDG)'s Office Order No. 11 of 2019-2020",
    date: "26/09/2019",
    subject:
      "To submit ATR for Complains received from different Govt Department",
  },
  {
    fileStoreId: "2e0326f1-50f0-4306-b08a-11e78b83877e",
    label: "DG(BLDG)'s Office Order No. 09 of 2019-2020",
    date: "24/08/2019",
    subject: "Management of insecure building and temporary rehabilitation",
  },
  {
    fileStoreId: "46845b98-74e3-4ea1-8bfd-eefb9a2b73d5",
    label: "DG(BLDG)'s Office Order No. 08 of 2019-2020",
    date: "07/08/2019",
    subject:
      "SOP for new construction and demolition of buildings to reduce dust pollution",
  },
  {
    fileStoreId: "18332358-d8bb-4fd2-a4f9-73572f5980e7",
    label: "DG(BLDG)'s Office Order No. 04 of 2019-2020",
    date: "11/05/2019",
    subject: "Requisition of Market value from IGR",
  },
  {
    fileStoreId: "662431f7-ce50-425b-99b7-c23d11f6ddb3",
    label: "DG(BLDG)'s Office Order No. 03 of 2019-2020",
    date: "08/05/2019",
    subject: "LBS-Architect withdrawal application form",
  },
  {
    fileStoreId: "ab060fe4-fb84-4129-b9e2-210dbd903d93",
    label: "DG(BLDG)'s Office Order No. 01 of 2019-2020",
    date: "04/04/2019",
    subject: "Reporting after demolition us 400(8), 411, 400(1)",
  },
];

const Building_OfficeOreder_2019 = () => (
  <TableStructure
    title="Office Order/ 2019"
    heading={false}
    list={List}
    columnNo={3}
    firstColumnName="Office Order No"
    leftMenuList={BuildingOfficeOrderSiteMenuList}
    longMenuList={true}
  />
);

export default Building_OfficeOreder_2019;
